import ContentBox from '@components/common/ContentBox';
import PageHeader from '@components/common/PageHeader';
import AuthFormField from '@components/common/form/AuthFormField';
import { Form, Formik } from 'formik';
import React, { useContext, useState } from 'react';
import * as Yup from 'yup';
import LargeBlueButton from '@components/common/button/LargeBlueButton';
import firebase from 'firebase/app';
import 'firebase/auth';
import { GenericAuthContext } from '@src/authContexts';
import HorizontalCenter from '@components/common/alignment/HorizontalCenter';
import { useHistory } from 'react-router';

const ChangePassword: React.FC = () => {
  const history = useHistory();

  const { user } = useContext(GenericAuthContext);

  const [changeErrorState, setChangeErrorState] = useState('');

  const validationSchema = Yup.object().shape({
    currentPassword: Yup.string().required('Required.'),
    newPassword: Yup.string().required('Required.'),
    confirmPassword: Yup.string().oneOf([Yup.ref('newPassword')], 'Passwords do not match.'),
  });

  const changePassword = async ({
    currentPassword,
    newPassword,
  }: {
    currentPassword: string;
    newPassword: string;
  }) => {
    if (!user.email) {
      setChangeErrorState(
        "You somehow don't have an email. Please try signing in again and then changing your password."
      );
      return;
    }

    const credentials = firebase.auth.EmailAuthProvider.credential(user.email, currentPassword);

    try {
      await user.reauthenticateWithCredential(credentials);
    } catch (e) {
      setChangeErrorState('Failed to authenticate. Is your current password correct?');
      return;
    }

    try {
      await user.updatePassword(newPassword);
    } catch (e) {
      setChangeErrorState('Failed to change your password. Please try again.');
      return;
    }

    history.push('/');
  };

  return (
    <div className='h-full overflow-auto'>
      <PageHeader text='CHANGE PASSWORD'></PageHeader>
      <div className='mt-20'>
        <HorizontalCenter>
          <ContentBox>
            <Formik
              initialValues={{ currentPassword: '', newPassword: '', confirmPassword: '' }}
              onSubmit={changePassword}
              validationSchema={validationSchema}
            >
              <Form
                className='w-full h-full flex flex-col font-raleway'
                onChange={() => {
                  if (changeErrorState !== '') {
                    setChangeErrorState('');
                  }
                }}
              >
                <AuthFormField
                  name='currentPassword'
                  text='CURRENT PASSWORD'
                  placeholder='Current Password'
                  type='password'
                ></AuthFormField>
                <AuthFormField
                  name='newPassword'
                  text='NEW PASSWORD'
                  placeholder='New Password'
                  type='password'
                ></AuthFormField>
                <AuthFormField
                  name='confirmPassword'
                  text='CONFIRM PASSWORD'
                  placeholder='Confirm Password'
                  type='password'
                ></AuthFormField>
                <div className='mt-10'>
                  <p className='text-red-600 text-center'>{changeErrorState}</p>
                  <div className='text-center justify-self-end mt-4 mb-8'>
                    <LargeBlueButton text='CHANGE PASSWORD' type='submit'></LargeBlueButton>
                  </div>
                </div>
              </Form>
            </Formik>
          </ContentBox>
        </HorizontalCenter>
      </div>
    </div>
  );
};

export default ChangePassword;
